const nav = document.querySelector('.kame-article__toc');

if (nav) {
  const links = [...nav.querySelectorAll('a[href^="#"]')];
  const targets = links.map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1))));
  let frame = 0;
  let current = -1;

  const update = () => {
    frame = 0;
    const line = window.innerHeight * 0.3;
    let active = 0;
    targets.forEach((target, index) => {
      if (target && target.getBoundingClientRect().top <= line) active = index;
    });
    if (active === current) return;
    current = active;
    links.forEach((link, index) => {
      if (index === active) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  };

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };

  document.addEventListener('scroll', schedule, { capture: true, passive: true });
  window.addEventListener('resize', schedule);
  update();
}
